document.addEventListener('DOMContentLoaded', function() {
    const mobileMenuButton = document.getElementById('mobile-menu-button');
    const mobileMenu = document.getElementById('mobile-menu');
    const overlay = mobileMenu?.querySelector('div:first-child');
    const menuDrawer = mobileMenu?.querySelector('div:nth-child(2)');
    const body = document.body;
    let activeMenuItem = null;

    function closeMenu() {
        // Remove overflow-hidden immediately to restore scrolling
        body.classList.remove('overflow-hidden');
        
        // Start the closing animation
        overlay.classList.add('opacity-0');
        menuDrawer.classList.add('translate-x-full');
        
        // Hide the menu after animation completes
        setTimeout(() => {
            mobileMenu.classList.add('hidden');
            // Reset any open submenus
            const openSubmenus = mobileMenu.querySelectorAll('.sub-menu:not(.hidden)');
            openSubmenus.forEach(sub => sub.classList.add('hidden'));
            const activeToggles = mobileMenu.querySelectorAll('.submenu-active');
            activeToggles.forEach(item => item.classList.remove('submenu-active'));
            const rotatedArrows = mobileMenu.querySelectorAll('.rotate-180');
            rotatedArrows.forEach(arrow => arrow.classList.remove('rotate-180'));
        }, 300);
    }

    // Get the close button
    const closeButton = document.getElementById('close-mobile-menu');

    if (mobileMenuButton && mobileMenu && menuDrawer) {
        // Add event listener for close button
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                // Immediately remove overflow-hidden from body
                document.body.classList.remove('overflow-hidden');
                // Then close the menu
                closeMenu();
            });
        }
        mobileMenuButton.addEventListener('click', function() {
            if (mobileMenu.classList.contains('hidden')) {
                mobileMenu.classList.remove('hidden');
                body.classList.add('overflow-hidden');
                requestAnimationFrame(() => {
                    overlay.classList.remove('opacity-0');
                    menuDrawer.classList.remove('translate-x-full');
                });
            } else {
                closeMenu();
            }
        });

        document.addEventListener('click', function(event) {
            if (!menuDrawer.contains(event.target) && !mobileMenuButton.contains(event.target) && !mobileMenu.classList.contains('hidden')) {
                closeMenu();
            }
        });

        const menuItems = mobileMenu.querySelectorAll('.menu-item-has-children');
        menuItems.forEach(menuItem => {
            const link = menuItem.querySelector('a');
            const wrapper = document.createElement('div');
            wrapper.className = 'flex items-center justify-between py-1 sub';
            link.parentNode.insertBefore(wrapper, link);
            wrapper.appendChild(link);

            const submenuToggle = document.createElement('button');
            submenuToggle.className = 'submenu-toggle p-2 text-white focus:outline-none';
            submenuToggle.innerHTML = '<svg class="w-6 h-6 transform transition-all duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path></svg>';
            wrapper.appendChild(submenuToggle);

            const submenu = menuItem.querySelector('.sub-menu');
            if (submenu) {
                submenu.classList.add('hidden', 'overflow-hidden', 'transition-all', 'duration-300', 'ease-in-out');
                submenu.style.maxHeight = '0';

                function closeSubmenu(item, sub) {
                    if (sub) {
                        // First close all child submenus
                        const openSubmenus = sub.querySelectorAll('.sub-menu:not(.hidden)');
                        openSubmenus.forEach(childSub => {
                            childSub.classList.add('hidden');
                            childSub.style.maxHeight = null;
                            const childItem = childSub.closest('.menu-item-has-children');
                            if (childItem) {
                                childItem.classList.remove('submenu-active');
                                const toggle = childItem.querySelector('.submenu-toggle svg');
                                if (toggle) toggle.classList.remove('rotate-180');
                            }
                        });
                        
                        // Then close this submenu
                        sub.classList.add('hidden');
                        sub.style.maxHeight = null;
                        
                        // Reset only this item's toggle and active state
                        const toggle = item.querySelector('.submenu-toggle svg');
                        if (toggle) toggle.classList.remove('rotate-180');
                        item.classList.remove('submenu-active');
                    }
                }

                function toggleSubmenu(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const submenuToggle = e.currentTarget;
                    const menuItem = submenuToggle.closest('.menu-item-has-children');
                    const submenu = menuItem.querySelector('.sub-menu');

                    // Find the parent submenu if this is a nested item
                    const parentSubmenu = menuItem.closest('.sub-menu');
                    const isNestedSubmenu = !!parentSubmenu;

                    // Only handle siblings at the same level
                    const siblingItems = (isNestedSubmenu ? parentSubmenu : menuItem.parentElement).querySelectorAll(':scope > .menu-item-has-children');
                    siblingItems.forEach(sibling => {
                        if (sibling !== menuItem) {
                            const siblingSubmenu = sibling.querySelector('.sub-menu');
                            if (siblingSubmenu && !siblingSubmenu.classList.contains('hidden')) {
                                closeSubmenu(sibling, siblingSubmenu);
                            }
                        }
                    });

                    if (submenu.classList.contains('hidden')) {
                        // Open this submenu
                        submenu.classList.remove('hidden');
                        let totalHeight = submenu.scrollHeight;
                        submenu.style.maxHeight = totalHeight + 'px';
                        
                        // Update parent submenu heights if this is a nested submenu
                        if (isNestedSubmenu) {
                            let parent = parentSubmenu;
                            while (parent) {
                                parent.style.maxHeight = (parseInt(parent.style.maxHeight || 0) + totalHeight) + 'px';
                                parent = parent.parentElement?.closest('.sub-menu');
                            }
                        }
                        
                        // Only activate the clicked toggle
                        submenuToggle.querySelector('svg').classList.add('rotate-180');
                        menuItem.classList.add('submenu-active');
                        
                        // If this is a top-level item, remove active state from other top-level items
                        if (!isNestedSubmenu && activeMenuItem && activeMenuItem !== menuItem) {
                            closeSubmenu(activeMenuItem, activeMenuItem.querySelector('.sub-menu'));
                        }
                        activeMenuItem = !isNestedSubmenu ? menuItem : activeMenuItem;
                    } else {
                        closeSubmenu(menuItem, submenu);
                        if (!isNestedSubmenu) {
                            activeMenuItem = null;
                        }
                    }
                }

                submenuToggle.addEventListener('click', toggleSubmenu);
            }
        });

        const allSubmenus = mobileMenu.querySelectorAll('.sub-menu');
        allSubmenus.forEach(submenu => {
            submenu.classList.add('hidden');
        });

        window.addEventListener('resize', function() {
            if (window.innerWidth >= 1024 && !mobileMenu.classList.contains('hidden')) {
                closeMenu();
            }
        });
    }
});
